import { render, staticRenderFns } from "./FederationGroupsTable.vue?vue&type=template&id=62584ea0&"
import script from "./FederationGroupsTable.vue?vue&type=script&lang=js&"
export * from "./FederationGroupsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports